import React, { Component } from 'react';
import { Button, Col, Divider, Form, Row, Select } from 'antd';
import Big from 'big.js';
// import moment from "moment";
import Pie2 from '@comm/charts/Pie2/Index';
import Rank from '@comm/charts/Rank/Index';
import Line from '@comm/charts/Line2/Index';
import YearPicker from '@comm/YearPicker';
import { queryBudgetAnalysisBudget, queryBudgetAnalysisBudgetMonth } from '@api/finance/budget';
import '../analyze.less';

const FormItem = Form.Item;
const month = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
// const currentYear = moment.unix(new Date().getTime() / 1000).format("YYYY");
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: {},
      legendData: [],
      pieData2: [],
      beginYear: `${this.props.location.query.year - 1}`,
      endYear: this.props.location.query.year,
      beginData: [],
      endData: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { year } = this.props.location.query;
    this.condition = {
      beginDate: `${year}-01-01`,
      endDate: `${year}-12-31`,
    };
    this.getAnalysisBudget();
    this.getAnalysisBudgetMonth();
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition || {}).some(
        key => nextProps.condition[key] !== this.condition[key],
      )
    ) {
      this.condition = nextProps.condition;
      this.getAnalysisBudget();
      this.getAnalysisBudgetMonth();
    }
  }

  findTypeName = key => {
    let typeName = '';
    const { expendType } = this.props;
    expendType.forEach(item => {
      if (key === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  getAnalysisBudget = () => {
    let sum = new Big(0);
    const groupUuids = this.props.params.uuid.split(',');
    queryBudgetAnalysisBudget({
      groupUuids,
      target: 0,
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        const pieData2 = [];
        const legendData = [];
        const selected = {};
        res.data.forEach((item, index) => {
          sum = sum.plus(new Big(item.price || 0));
          const typeName = this.findTypeName(item.type) || '未定义类型';
          legendData.push(typeName);
          selected[typeName] = index < 15;
          pieData2.push({
            name: typeName,
            value: item.price,
          });
        });
        this.setState({
          selected,
          pieData2,
          legendData,
        });
      }
    });
  };

  getAnalysisBudgetMonth = () => {
    const { beginYear, endYear, type } = this.props.form.getFieldsValue();
    const groupUuids = this.props.params.uuid.split(',');
    queryBudgetAnalysisBudgetMonth({
      groupUuids,
      type: type === '-1' ? '' : type,
      target: 0,
      beginYear,
      endYear,
    }).then(res => {
      const beginData = [];
      const endData = [];
      if (res.statusCode === 200) {
        for (let i = 0; i < month.length; i++) {
          beginData.push(res.data[beginYear][month[i]] || 0);
          endData.push(res.data[endYear][month[i]] || 0);
          this.setState({
            beginYear,
            endYear,
            beginData,
            endData,
          });
        }
      }
    });
  };

  handleSearch = () => {
    this.getAnalysisBudgetMonth();
  };

  render() {
    const { beginYear, endYear, beginData, endData, legendData, pieData2, selected } = this.state;
    const {
      form: { getFieldDecorator },
    } = this.props;
    const line2Props = {
      title: '月支出对比',
      legend: [beginYear, endYear],
      xAxisData: month,
      series: [
        {
          name: beginYear,
          type: 'line',
          data: beginData,
        },
        {
          name: endYear,
          type: 'line',
          data: endData,
        },
      ],
    };
    const pieData3 = {
      title: '支出类型统计',
      selected,
      legendData,
      seriesData: pieData2,
    };
    const { expendType } = this.props;
    return (
      <div className="analyze">
        <Row>
          <Col span={16}>
            <Pie2 data={pieData3} />
          </Col>
          <Col span={8}>
            <Rank data={pieData2} title="支出类型排名" />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col span={6}>
            <FormItem>月支出对比(单位：元)</FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              {getFieldDecorator('type', {
                initialValue: '-1',
              })(
                <Select style={{ width: '150px' }}>
                  <Select.Option value="-1">全部</Select.Option>
                  {expendType.map(item => (
                    <Select.Option value={item.value} key={item.value}>
                      {item.key}
                    </Select.Option>
                  ))}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              {getFieldDecorator('beginYear', {
                initialValue: beginYear,
              })(<YearPicker style={{ width: '150px' }} />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              {getFieldDecorator('endYear', {
                initialValue: endYear,
              })(<YearPicker style={{ width: '150px' }} />)}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              <Button onClick={this.handleSearch} type="primary">
                查询
              </Button>
            </FormItem>
          </Col>
        </Row>
        <Line {...line2Props} />
      </div>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/finance/budget/balance/expend/TabChart.js